/* eslint-disable @typescript-eslint/no-use-before-define */
import { Map } from "ol";
import { easeOut } from "ol/easing";
import { FeatureLike } from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import BaseLayer from "ol/layer/Base";
import { unByKey } from "ol/Observable";
import { getVectorContext } from "ol/render";
import RenderEvent from "ol/render/Event";
import { Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";

const maxRadius = 30;
const minRadius = 5;
const duration = 3000;

export function focusAnimation(
  layer: BaseLayer,
  feature: FeatureLike,
  map: Map,
): void {
  const start = Date.now();
  const flashGeom = (feature.getGeometry() as Geometry).clone();
  const listenerKey = layer.on("postrender", animate);

  function animate(event: RenderEvent) {
    const { frameState } = event;
    const elapsed = frameState.time - start;
    if (elapsed >= duration) {
      unByKey(listenerKey);
      return;
    }
    const vectorContext = getVectorContext(event);
    const elapsedRatio = elapsed / duration;
    const radius = easeOut(elapsedRatio) * (maxRadius - minRadius) + minRadius;
    const opacity = easeOut(1 - elapsedRatio);
    const style = new Style({
      image: new CircleStyle({
        radius,
        stroke: new Stroke({
          color: `rgba(46, 139, 87, ${opacity})`,
          width: 0.25 + opacity,
        }),
      }),
    });
    vectorContext.setStyle(style);
    vectorContext.drawGeometry(flashGeom);
    // tell OpenLayers to continue postrender animation
    map.render();
  }
}
